import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { modalOverlayStyles, modalContainerStyles, modalHeaderStyles } from '../styles/commonStyles';
import CloseButton from './Buttons/CloseButton';

const ModalLayout = ({ isOpen, onClose, title, children, showCloseButton = false }) => {
    useEffect(() => {
        if (!isOpen) return;
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, onClose]);
    return isOpen ? createPortal(
        <>
            <div className={modalOverlayStyles} onClick={onClose} />
            <div className={modalContainerStyles}>
                {(title || showCloseButton) && (
                    <div className="flex items-center justify-between mb-4">
                        {title && <h2 className={modalHeaderStyles}>{title}</h2>}
                        {showCloseButton && <CloseButton onClick={onClose} />}
                    </div>
                )}
                {children}
            </div>
        </>,
        document.body
    ) : null;
};

export default ModalLayout;
